import {
    ProFormDateTimePicker,
    ProFormSelect,
    ProFormSwitch,
    ProFormText,
    ProFormTextArea
} from "@ant-design/pro-components";
import MyWangEditor from "./MyWangEditor";
import MyUploadImage from "./MyUploadImage";
import React from "react";
import MyRawData from "./MyRawData";
import {MyTinyMCEEditor} from "./MyTinyMCEEditor";
import {Button, Col, Row} from "antd";
import {EyeFilled} from "@ant-design/icons";

const MyProFormItems = (props: any) => {
    return (<Row gutter={0} style={{width:'100%'}}>
        {props.columns.sort((a: any, b: any) => b.order - a.order)
            .map((col: any, i: number) => {
            if (!col.hideInForm) {
                switch (col.valueType) {
                    case "dateTime":
                        return <ProFormDateTimePicker key={i}
                                                      name={col.dataIndex}
                                                      label={col.title}
                                                      formItemProps={{rules: [{required: col.required}]}}
                        />
                    case "select":
                        return <ProFormSelect
                                              name={col.dataIndex}
                                              label={col.title}
                                              options={col.valueEnum || col.fieldProps.options}
                                              formItemProps={{rules: [{required: col.required}]}}
                        />;
                    case "textArea":
                        return <ProFormTextArea key={i}
                                                name={col.dataIndex}
                                                label={col.title}
                                                fieldProps={{style: {height: col.height}}}
                                                formItemProps={{rules: [{required: col.required}]}}
                        />
                    case 'switch':
                        return <ProFormSwitch key={i}
                                              name={col.dataIndex}
                                              label={col.title} />
                    case "rich":
                        return <MyWangEditor key={i}
                                             name={col.dataIndex}
                                             label={col.title}
                                             value={(props.info as any)?.[col.dataIndex] || ""}
                                             formRef={props.formRef}
                                             required={col.required}
                        />
                    case "rich2":
                        return <MyTinyMCEEditor key={i}
                                             name={col.dataIndex}
                                             label={col.title}
                                             value={(props.info as any)?.[col.dataIndex] || ""}
                                             formRef={props.formRef}
                                             required={col.required}
                        />
                    case "image":
                        return <MyUploadImage key={i}
                                              name={col.dataIndex}
                                              label={col.title}
                                              value={(props.info as any)?.[col.dataIndex] || ""}
                                              formRef={props.formRef}
                                              required={col.required}
                        />
                    case 'json':
                        return <MyRawData key={i}
                                          rawData={(props.info as any)?.[col.dataIndex]}
                                          label={col.title}
                                          name={col.dataIndex}
                                          editable={true}
                                          formRef={props.formRef}/>

                    case "readonly":
                        return <ProFormText name={col.dataIndex} label={col.title} key={i} readonly/>

                    case "preview":
                        return ""

                    default:
                        return <Col span={24}>
                            <ProFormText name={col.dataIndex} label={col.title} key={i}
                                         formItemProps={{rules: [{required: col.required}]}} />
                        </Col>
                }
            } else {
                return ""
            }
        })
        }
    </Row>)
}

export default MyProFormItems;
